export default __webpack_public_path__ + "static/media/vscode.b8b1e001.svg";